import { render, staticRenderFns } from "./reason-wrong-info.vue?vue&type=template&id=1670e5a8&scoped=true"
import script from "./reason-wrong-info.vue?vue&type=script&lang=js"
export * from "./reason-wrong-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670e5a8",
  null
  
)

export default component.exports